import moment from "moment";
import React from "react";

import { useLocalStorage } from "../../../hooks";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwContainer, TwMainLayout } from "../../../components/tailwind";
import { setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { displayAvailablePaymentMethods } from "../../../utils/constants";
import PurchaseDetailActionPopover from "./PurchaseDetailActionPopover";


export default function PurchaseDetails({ navigation }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const [userToken] = useLocalStorage("userToken");
    const [purchaseInfo, setPurchaseInfo] = React.useState();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const fetchBookingsDetails = async () => {
        console.log("location.state.purchaseId", location.state.purchaseId);
        const config = {
            method: "get",
            // url: `${getUrlForBookings()}getMyPurchases?purchaseId=${location.state.purchaseId}&passId=${location.state.passId}`,
            url: `${getUrlForBookings()}getMyPurchases?purchaseId=${location.state.purchaseId}`,
        };
        dispatch(setGlobalLoading(true));
        const request = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                setPurchaseInfo(request.data.data)
            }
        }
    }

    React.useEffect(() => {
        fetchBookingsDetails()
    }, [])

    const calculateBoughtTickets = () => {
        let totalBookedTickets = 0;

        if (getPaymentMethod() === "classPass") {
            purchaseInfo?.passesBought.forEach((item) => {
                totalBookedTickets = totalBookedTickets + parseInt(item.purchasingQty)
            })
        } else if (purchaseInfo && purchaseInfo?.passesBought?.length) {
            purchaseInfo?.passesBought.forEach((item) => {
                totalBookedTickets = totalBookedTickets + parseInt(item.purchasingQty)
            })
        }

        return totalBookedTickets
    }

    const calculateTotalPrice = () => {
        let totalPrice = 0;
        let serviceFees = 0;

        if (purchaseInfo?.amount) {
            return parseFloat(purchaseInfo?.amount || 0).toFixed(2)
        } else {
            if (purchaseInfo && purchaseInfo?.passesBought?.length) {
                purchaseInfo?.passesBought.forEach((item) => {
                    serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.purchasingQty))
                    totalPrice = totalPrice + parseFloat(item.totalPrice)
                })
            }

            // return parseFloat(totalPrice + serviceFees).toFixed(2)
            return parseFloat(totalPrice).toFixed(2)
        }
    }

    const calculateUsersReceiveTotalPrice = () => {
        let amountToUser = 0;

        if (purchaseInfo && purchaseInfo?.passesBought?.length) {
            purchaseInfo?.passesBought.forEach((item) => {
                amountToUser = amountToUser + parseFloat(item?.amountToUser || 0)
            })
        }

        return parseFloat(amountToUser).toFixed(2)

    }

    const calculateServiceFees = () => {
        let serviceFees = 0;

        if (purchaseInfo && purchaseInfo?.passesBought?.length) {
            purchaseInfo?.passesBought.forEach((item) => {
                serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.purchasingQty))
            })
        }

        return parseFloat(serviceFees).toFixed(2)
    }

    const calculatePaymentServiceFees = () => {

        if (purchaseInfo?.totalPaymentServiceFee) {
            return parseFloat(purchaseInfo?.totalPaymentServiceFee).toFixed(2)
        }
        return parseFloat(0).toFixed(2)
    }

    const getConsumerInfo = () => {
        let consumerDetails = {}

        // if (purchaseInfo && purchaseInfo?.schedule_class_detail?.participants?.length) {
        //     consumerDetails = purchaseInfo?.schedule_class_detail?.participants.find((item) => item?.purchaseId === purchaseInfo.purchaseId)
        // }

        if (purchaseInfo) {
            consumerDetails = purchaseInfo?.consumer_detail
        }

        return consumerDetails;
    }

    const getPaymentStatus = () => {
        let paymentStatus = purchaseInfo?.paymentStatus;
        // if ((purchaseInfo?.paymentStatus == "Paid" || purchaseInfo?.paymentStatus == "Free") && purchaseInfo.paymentMethod == "NA" && parseInt(purchaseInfo.amount) <= 0) {
        //     paymentStatus = 'Free';
        // }
        var displayContent = (<button
            className={
                "h-8 bg-brown-coffee rounded-lg ml-4 px-3"
            }
            onClick={() => null}
        >
            <p className={"font-bold text-sm text-white text-center"}>
                {paymentStatus}

            </p>
        </button>)
        if (purchaseInfo?.status == "Cancelled" && (purchaseInfo?.paymentStatus == "Unpaid" || purchaseInfo?.paymentStatus == "Not-refunded") && purchaseInfo.paymentMode != "Online") {
            displayContent = (<span>{displayContent}<br></br> <span className="ml-4 text-gray-600">Customer never paid for it</span></span>);
        } else if (purchaseInfo?.status == "Cancelled" && purchaseInfo?.paymentStatus == "Not-refunded" && purchaseInfo.paymentMode == "NA" && parseInt(purchaseInfo.amount) <= 0) {
            displayContent = (<span>{displayContent}<br></br> <span className="ml-4 text-gray-600">It was a free service</span></span>);
        }

        return displayContent
    };

    const getPaymentMethod = () => {
        if (purchaseInfo?.paymentMethod && purchaseInfo?.paymentMethod !== 'NA') {
            return Object.keys(displayAvailablePaymentMethods).indexOf(purchaseInfo?.paymentMethod) >= 0 ? displayAvailablePaymentMethods[purchaseInfo?.paymentMethod] : "UNKNOWN";
        } /* else if (purchaseInfo?.paymentStatus == "Unpaid" && purchaseInfo.paymentMethod == "NA" && purchaseInfo.paymentMode != "Online" && parseInt(purchaseInfo.amount) > 0) {
            return 'pay at venue';
        } else if ((purchaseInfo?.paymentStatus == "Paid" || purchaseInfo?.paymentStatus == "Free") && purchaseInfo.paymentMethod == "NA" && parseInt(purchaseInfo.amount) <= 0) {
            //return 'Free';
            return 'Not Applicable';
        } */
        return 'UNKNOWN';
    };

    const getAmountPaid = () => {

        let amountPaid = "€0.00";

        if (purchaseInfo && purchaseInfo?.passesBought?.length) {
            purchaseInfo?.passesBought.forEach((item) => {
                amountPaid = `€${parseFloat(parseFloat(item?.amount ? item?.amount : 0)).toFixed(2)} `
            })
        }

        return amountPaid
    }

    console.log("purchaseInfo", purchaseInfo)

    return (
        <TwMainLayout
            headTitle={`Purchase Details`}
            breadcrumbs={[
                { title: "Pass Detail", onClick: () => { navigation(-1); } },
                { title: `${purchaseInfo?.purchaseId}` },
            ]}

            headActions={[
                // (<button
                //     className={"bg-blue-bz text-white rounded w-40 p-3"}
                //     onClick={handlePopoverOpen}
                // >
                //     <span className={"flex flex-row items-center"}>
                //         <p className={"w-full"}>Action</p>
                //         <img src={dropdownbottom} alt={""} />
                //     </span>
                // </button>),
            ]}
            children={
                <TwContainer className="">
                    <div className="flex flex-col gap-6 w-full">
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Purchase ID</p>
                                <p className="text-gray-500 text-xl sm:text-3xl font-bold">: {purchaseInfo?.purchaseId}</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Purchase Status</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span style={{ ...((purchaseInfo?.status && purchaseInfo?.status === "Cancelled") ? { color: '#FF4040' } : {}) }}>{purchaseInfo?.status}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Purchase Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{moment(purchaseInfo?.bookingDate).format('DD-MM-YYYY')}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Cancellation Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{purchaseInfo?.status?.toLowerCase() === "cancelled" ? moment(purchaseInfo?.cancellationDate).format('DD-MM-YYYY') : 'Not Applicable'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Status</p>
                                <span className="text-base">
                                    <span>:</span>
                                    {getPaymentStatus(purchaseInfo)}
                                    {/* <button
                                        className={
                                            "h-8 bg-brown-coffee rounded-lg ml-4 px-3"
                                        }
                                        onClick={() => null}
                                        >
                                        <p className={"font-bold text-sm text-white text-center"}>
                                            {purchaseInfo?.paymentStatus}
                                        </p>
                                    </button> */}
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Customer Details</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Full Name</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getConsumerInfo()?.fullName ? getConsumerInfo()?.fullName : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Email</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="text-indigo-bz">{getConsumerInfo()?.email ? getConsumerInfo()?.email : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Mobile Number</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getConsumerInfo()?.username ? "" + getConsumerInfo()?.username : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">City</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{purchaseInfo?.schedule_class_detail?.location?.city}</span>
                                </span>
                            </div> */}
                        </div>
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Purchase Details</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Activity Bought</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    {/* <span className="">{purchaseInfo?.schedule_class_detail?.className ? purchaseInfo?.schedule_class_detail?.className : purchaseInfo?.className}</span> */}
                                    <span className="">{purchaseInfo?.selectedPassDetail?.passName ? purchaseInfo?.selectedPassDetail?.passName : purchaseInfo?.className}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Total Allowed Sessions</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    {/* <span className="">{purchaseInfo?.schedule_class_detail?.className ? purchaseInfo?.schedule_class_detail?.className : purchaseInfo?.className}</span> */}
                                    <span className="">{purchaseInfo?.selectedPassDetail?.productType == "classpass" ? (purchaseInfo?.selectedPassDetail?.noOfAllowedSessions ? purchaseInfo?.selectedPassDetail?.noOfAllowedSessions : "0") : "Unlimited"}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Expiry Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    {/* <span className="">{purchaseInfo?.schedule_class_detail?.className ? purchaseInfo?.schedule_class_detail?.className : purchaseInfo?.className}</span> */}
                                    <span className="">{purchaseInfo?.selectedPassDetail?.validUntilConsumed ? "Until Consumed" : `${purchaseInfo?.selectedPassDetail?.validityDays} Days`}</span>
                                </span>
                            </div>
                            {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Activity Status</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span style={{ ...((purchaseInfo?.schedule_class_detail && purchaseInfo?.schedule_class_detail?.eventStatus === "Cancelled") ? { color: '#FF4040' } : {}) }}>{purchaseInfo?.schedule_class_detail?.eventStatus ? (purchaseInfo?.schedule_class_detail?.eventStatus === "Cancelled" ? "This event is cancelled" : purchaseInfo?.schedule_class_detail?.eventStatus) : 'UNKNOWN'}</span>
                                </span>
                            </div> */}

                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Amount Paid</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getAmountPaid()}</span>
                                </span>
                            </div>

                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Platform Service Fee</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{`€${calculateServiceFees()}`}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Method</p>
                                <span className="text-base flex gap-5 capitalize">
                                    <span>:</span>
                                    <span className=""> {getPaymentMethod()}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Processing Fee</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{`€${calculatePaymentServiceFees()}`}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <div className="flex px-3 py-1 rounded bg-zinc-300">
                                    <p className="text-base min-w-36 w-36 sm:w-48">Total Amount Paid</p>
                                    <span className="text-base flex gap-5">
                                        <span>:</span>
                                        <span className="">{`€${calculateTotalPrice()} `} <span className="text-gray-600">Including VAT & Service Fee</span></span>
                                    </span>
                                </div>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Your Payout</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{`€${calculateUsersReceiveTotalPrice()}`} </span>
                                </span>
                            </div>
                        </div>

                    </div>
                    {purchaseInfo ? <PurchaseDetailActionPopover
                        purchasingDetails={purchaseInfo}
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        handleUpdate={fetchBookingsDetails}
                    /> : null}

                </TwContainer>} />
    );
}
